import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownButtonLabel from '../../shared/styledComponents/DropdownButtonLabel';

export default InjectedStyledComponent(DropdownButtonLabel, 'iconDropdown', ['buttonLabel']);